


















import Vue from 'vue'
import {
  computed,
  defineComponent,
  getCurrentInstance,
  PropType,
  ref,
  useRoute,
  useRouter,
} from '@nuxtjs/composition-api'
import {
  accountModule,
  authModule,
  deviceModule,
  repairModule,
  screenModule,
  toastModule,
} from '@app/store'
import SystemConstants from '@app/constants/SystemConstants'
import useAccount from '@app/composable/useAccount'
import CpLinkArrow from '@ui/src/components/CpLinkArrow/CpLinkArrow.vue'
import CpButton from '@ui/src/components/CpButton/CpButton.vue'
import CpModal from '@ui/src/components/CpModal/CpModal.vue'
export default defineComponent({
  components: {
    CpLinkArrow,
    CpButton,
    CpModal,
  },
  middleware: 'authenticated',
  setup(prop) {
    const root = getCurrentInstance()

    const i18n = root?.proxy.$i18n!

    const logoutModal = ref(null)
    const router = useRouter()
    const url = root?.proxy.$urls!
    const observer = ref<any>()

    const show = () => {
      ;(logoutModal.value as any).show()
    }
    const {
      isSalon,
      isIndivisual,
      name,
      nameFrigana,
      lineId,
      email,
      tel,
      zipcode,
      address,
      salonName,
      salonTel,
      salonUrl,
      corporateName,
      representative,
    } = useAccount()

    const logout = () => {
      authModule
        .signOut()
        .then(() => {
          localStorage.setItem(SystemConstants.redirectKey, '')
          accountModule.clearAll()
          deviceModule.clearAll()
          repairModule.clearAll()
          window.location.href = url.login
        })
        .catch((e) => {
          toastModule.show({
            message: i18n
              .t('ログアウトに失敗しました。画面を更新して再度お試しください。')
              .toString(),
            variant: 'error',
            showMs: 8000,
            loginError: false,
          })
        })
    }

    return {
      show,
      isSalon,
      isIndivisual,
      name,
      nameFrigana,
      lineId,
      email,
      tel,
      zipcode,
      address,
      salonName,
      salonTel,
      salonUrl,
      logout,

      observer,

      logoutModal,
      corporateName,
      representative,
    }
  },
})
